import React, { useState, useEffect } from "react";
import { FiX } from "react-icons/fi";
import "./PromoBar.css";
import useTranslations from "../../../Hooks/useTranslations";
import translations from "./translations.json";

const PromoBar = () => {
  const t = useTranslations(translations);

  // Initialize visibility directly from localStorage to prevent flashing on remount
  // This ensures the state is correct from the first render, even when restaurantId or month changes
  const [isVisible, setIsVisible] = useState(() => {
    return localStorage.getItem("promoBarClosed") !== "true";
  });

  useEffect(() => {
    // Add class to body when visible, remove when not
    if (isVisible) {
      document.body.classList.add("promo-bar-visible");
    } else {
      document.body.classList.remove("promo-bar-visible");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("promo-bar-visible");
    };
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("promoBarClosed", "true");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="promo-bar-component">
      <a
        href="https://academy.happychef.cloud/course/reservatiesysteem-basics-training"
        target="_blank"
        rel="noopener noreferrer"
        className="promo-bar-link"
      >
        <span className="promo-bar-text">
          {t.promoText} <span style={{textDecoration: "underline"}}>{t.linkText}</span>
        </span>
      </a>
      <button
        className="promo-bar-close"
        onClick={(e) => {
          e.preventDefault();
          handleClose();
        }}
        aria-label={t.closeLabel}
      >
        <FiX size={20} />
      </button>
    </div>
  );
};

export default PromoBar;
